import { render, staticRenderFns } from "./catToUpload.vue?vue&type=template&id=c6a2f340&scoped=true"
import script from "./catToUpload.vue?vue&type=script&lang=js"
export * from "./catToUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6a2f340",
  null
  
)

export default component.exports